import {Component} from "react";
// import {connect} from "react-redux";
// import {IStore} from "../../store/IStore";
// import {Dispatch} from "redux";
//
var currencyFormatter = require('currency-formatter');
//
// interface IProps {
//     [x: string]: any;
//
//     // loader: {
//     //     config: {string:string}
//     // }
// }
//
// interface IState {
//
// }
//
// interface IStateToProps {
//
//     //reel_data: any,
//     // currentBetIndex: number,
//     // autoplayCount: number,
//     // betList: Array<number>
//
// }
//
// interface IDispatchToProps {
//     // startSpin:any;
//     // stopSpin:any;
//
// }
//
// class CurrencyManager extends Component<IProps, IState> {
//
//     protected currencyCode: string;
//     protected majorSymbol: string;
//     protected minorSymbol: string;
//     protected thouSeperator: string;
//     protected thouPlaces: number;
//     protected dpSeperator: string;
//     protected decimalPlaces: number;
//     protected currencyScale: number;
//     protected prefixMajor: boolean;
//     protected baseValue: number;
//
//     constructor(props: IProps) {
//         super(props);
//         this.currencyCode = this.props.currencyCode;
//         this.majorSymbol = this.props.majorSymbol;
//         this.minorSymbol = this.props.minorSymbol;
//         this.thouSeperator = this.props.thouSeperator;
//         this.thouPlaces = this.props.thouPlaces;
//         this.dpSeperator = this.props.dpSeperator;
//         this.decimalPlaces = this.props.decimalPlaces;
//         this.currencyScale = this.props.currencyScale;
//         this.prefixMajor = this.props.prefixMajor;
//         this.baseValue = this.props.baseValue;
//     }
//
//     replace(string: any, expression: any, replace: any) {
//         if (expression && expression !== "") {
//             return string.replace(expression, replace);
//         }
//         return string;
//     }
//
//     isFloat(n: any) {
//         return Number === n && n % 1 !== 0;
//     }
//
//     getPrecision(n: any) {
//         const split = n.toString().split(".");
//         return split[1] ? split[1].length : 0;
//     }
//
//     calculateDisplayedPrecision(value: any, decimalRoof: any) {
//         let precision = this.getPrecision(value.toPrecision());
//
//         if (precision < this.decimalPlaces) {
//             precision = this.decimalPlaces;
//         }
//
//         if (precision > decimalRoof) {
//             precision = decimalRoof;
//         }
//         return precision;
//     }
//
//     /**
//      *
//      * @param {Number} value
//      * @param {Boolean} showMajor
//      * @param {Boolean} showThousands
//      * @param {Boolean} showDecimal
//      * @param {Boolean} showMinor
//      * @returns {String}
//      */
//     public formatCurrencyString(value: any, showMajor: any, showThousands: any, showDecimal: any, showMinor: any, decimalRoof: any = this.decimalPlaces) {
//         var majorSymbol = showMajor === true ? this.majorSymbol : "",
//             thouSeperator = showThousands === true ? this.thouSeperator : "",
//             decimalPlaces = showDecimal ? decimalRoof || this.decimalPlaces : 0,
//             thouPlaces = this.thouPlaces,
//             tempString = "";
//
//         if (showDecimal && this.isFloat(value) && decimalPlaces === 0) {
//             decimalPlaces = 2;
//         }
//
//         const valueNum = Number(value);
//
//         if (!isFinite(valueNum) && typeof value === "string") {
//             value = currencyFormatter.unformat(value, {code: this.currencyCode});
//         }
//
//         value = isFinite(valueNum) ? valueNum : value;
//
//         const precision = this.calculateDisplayedPrecision(value, decimalRoof);
//
//         value = value * this.currencyScale;
//
//         return currencyFormatter.format(value, {
//             symbol: majorSymbol,
//             decimal: this.dpSeperator,
//             thousand: thouSeperator,
//             precision: showDecimal ? precision : 0,
//             format: this.prefixMajor ? "%s%v" : "%v%s"
//         });
//     }
//
//
//     /**
//      * Turns a formatted string back into a float
//      * @param {String} value
//      * @returns {Number}
//      */
//     public removeStringFormatting(value: any) {
//         return currencyFormatter.unformat(value, {code: this.currencyCode});
//     }
//
//     render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
//         return undefined;
//     }
// }
//
// // export default CurrencyManager;
// export default connect(
//     (state: Pick<IStore, 'currencyManagerState'>): any =>
//         ({
//             currencyCode: state.currencyManagerState.currencyCode,
//             majorSymbol: state.currencyManagerState.majorSymbol,
//             minorSymbol: state.currencyManagerState.minorSymbol,
//             thouSeperator: state.currencyManagerState.thouSeperator,
//             thouPlaces: state.currencyManagerState.thouPlaces,
//             dpSeperator: state.currencyManagerState.dpSeperator,
//             decimalPlaces: state.currencyManagerState.decimalPlaces,
//             currencyScale: state.currencyManagerState.currencyScale,
//             prefixMajor: state.currencyManagerState.prefixMajor,
//             baseValue: state.currencyManagerState.baseValue,
//             // reel_data: state.basegameState.reel_data,
//             // currentBetIndex: state.basegameState.currentBetIndex,
//             // autoplayCount: state.basegameState.autoplayCount,
//             // betList: state.basegameState.betList
//             // freegameSpinCount: state.freegameState.freegameSpinCount,
//             // scatterWinnings: state.freegameState.scatterWinnings,
//             // layoutMode: state.applicationState.layoutMode,
//         }),
//     (dispatch: Dispatch): any => ({
//         // startSpin: (): any => (this.onReelSpinStart),
//         //forcestopSpin: (): any => dispatch(reelsActions.forceStopSpin()),
//         // setApplicationToBaseGameState: (basegamestate: boolean): any => dispatch(basegameActions.setApplicationToBaseGameState(basegamestate)),
//         // setIntroDone: (): any => dispatch(basegameActions.setIntroDone()),
//         // startFreegame: (): any => dispatch(freegameActions.startFreegame()),
//         // stopFreegame: (): any => dispatch(freegameActions.stopFreegame()),
//         // nextFreegame: (): any => dispatch(freegameActions.nextFreegame()),
//         // stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
//         // setApplicationLayoutObject: (layoutobjectlist: string): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
//     }))(CurrencyManager)


 class CurrencyManager {
     protected currencyCode :string;
     protected majorSymbol :string;
     protected minorSymbol :string;
     protected thouSeperator :string;
     protected thouPlaces :number;
     protected dpSeperator :string;
     protected decimalPlaces :number;
     protected currencyScale :number;
     protected prefixMajor :boolean;
     protected baseValue :number;
     constructor() {

         this.currencyCode = "GBP";
         this.majorSymbol = "£";
         this.minorSymbol = "p";
         this.thouSeperator = ",";
         this.thouPlaces = 3;
         this.dpSeperator = ".";
         this.decimalPlaces = 2;
         this.currencyScale = 1;
         this.prefixMajor = true;
         this.baseValue = 0;
     }
     setCurrency(event:any) {
         this.currencyCode = event.currency.code.toUpperCase();
         this.majorSymbol = decodeURIComponent(event.currency.maj);
         this.minorSymbol = event.currency.min;
         this.thouSeperator = event.currency.gs;
         this.dpSeperator = event.currency.ds;
         this.currencyScale = event.currency.scale;
         if (event.currency.gp !== undefined) {
             this.thouPlaces = event.currency.gp;
         }
         if (event.currency.dp !== undefined) {
             this.decimalPlaces = event.currency.dp;
         }
         this.prefixMajor = event.currency.msp;
     }
     replace(string: any, expression: any, replace: any) {
         if (expression && expression !== "") {
             return string.replace(expression, replace);
         }
         return string;
     }

     isFloat(n: any) {
         return Number === n && n % 1 !== 0;
     }

     getPrecision(n: any) {
         const split = n.toString().split(".");
         return split[1] ? split[1].length : 0;
     }

     calculateDisplayedPrecision(value: any, decimalRoof: any) {
         let precision = this.getPrecision(value.toPrecision());

         if (precision < this.decimalPlaces) {
             precision = this.decimalPlaces;
         }

         if (precision > decimalRoof) {
             precision = decimalRoof;
         }
         return precision;
     }

     /**
      *
      * @param {Number} value
      * @param {Boolean} showMajor
      * @param {Boolean} showThousands
      * @param {Boolean} showDecimal
      * @param {Boolean} showMinor
      * @returns {String}
      */
     formatCurrencyString(value: any, showMajor: any, showThousands: any, showDecimal: any, showMinor: any, decimalRoof: any = this.decimalPlaces) {
         var majorSymbol = showMajor === true ? this.majorSymbol : "",
             thouSeperator = showThousands === true ? this.thouSeperator : "",
             decimalPlaces = showDecimal ? decimalRoof || this.decimalPlaces : 0,
             thouPlaces = this.thouPlaces,
             tempString = "";

         if (showDecimal && this.isFloat(value) && decimalPlaces === 0) {
             decimalPlaces = 2;
         }

         const valueNum = Number(value);

         if (!isFinite(valueNum) && typeof value === "string") {
             value = currencyFormatter.unformat(value, {code: this.currencyCode});
         }

         value = isFinite(valueNum) ? valueNum : value;

         const precision = this.calculateDisplayedPrecision(value, decimalRoof);

         value = value * this.currencyScale;

         return currencyFormatter.format(value, {
             code: this.currencyCode,
             symbol: currencyFormatter.currencies.filter((data:any)=>{
                if(data.code ==this.currencyCode){
                    return data.symbol
                }
             })[0] && currencyFormatter.currencies.filter((data:any)=>{
                if(data.code ==this.currencyCode){
                    return data.symbol
                }
             })[0].symbol || this.currencyCode,
             decimal: this.dpSeperator,
             thousand: thouSeperator,
             precision: showDecimal ? precision : 0,
             format: this.prefixMajor ? "%s%v" : "%v%s"
         });
     }

     /**
      * Turns a formatted string back into a float
      * @param {String} value
      * @returns {Number}
      */
     removeStringFormatting(value: any) {
         return currencyFormatter.unformat(value, {code: this.currencyCode});
     }
 }
 export default CurrencyManager;